import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { constantsData, identifiersData, namesData, statusTypesData, urlsData } from "@/data";
import { useApisClient } from "@/hooks";
import { openAlert, setRefetchDriveManagementList } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useCreateDriveManagementFolder = () => {
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { logout } = useAuth0();

    const { post } = useApisClient();

    const { createDriveManagementFolderPending: createDriveManagementFolderPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const createDriveManagementFolder = (folderName, id) => {
        setLoading(true);

        post(urlsData.apis.driveManagement.files.url, null, {
            name: folderName,
            parents: [id],
        })
            .then(() => {
                dispatch(
                    openAlert(
                        t("messages.createMsgs.success", { entity: t("labels.folder") }),
                        statusTypesData.success,
                    ),
                );
            })
            ["catch"]((err) => {
                displayErrorHandler(
                    err.response.data.message === constantsData.networkError
                        ? t("messages.networkFailure")
                        : err.response.data.message,
                    dispatch,
                    openAlert,
                    err.response.status,
                    logout,
                );
            })
            ["finally"](() => {
                toast.dismiss(`${createDriveManagementFolderPendingToastName}_${toastId}`);

                setLoading(false);

                dispatch(setRefetchDriveManagementList(true));
            });
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(() => t("messages.createMsgs.pending", { entity: t("labels.folder") }), {
                    toastId: `${createDriveManagementFolderPendingToastName}_${toastId}`,
                });
            }
        },
        [loading], //eslint-disable-line
    );

    return {
        createDriveManagementFolder,
        loading,
    };
};

export default useCreateDriveManagementFolder;
